<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <minimizable-modal :name="chainID"
                           :draggable="'.v-app-bar'"
                           :width="525"
                           height="auto"
                           :reset="true"
                           overlayTransition=""
                           transition=""
                           :clickToClose="false"
                           :shiftX="modalShift.x"
                           :shiftY="modalShift.y"
                           :minimized.sync="minimized"
                           :visible.sync="visible"
        >
            <v-app-bar color="primary" @dblclick="minimized = !minimized">
                <v-toolbar-title>
                    {{ chain.name }}
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <v-tooltip top v-if="!controller.active">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               @click.stop="startChain"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">play_arrow</v-icon>
                        </v-btn>
                    </template>
                    <span>Run</span>
                </v-tooltip>

                <v-tooltip top v-else>
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               @click.stop="stop"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">stop</v-icon>
                        </v-btn>
                    </template>
                    <span>Stop</span>
                </v-tooltip>

                <v-tooltip top v-if="!minimized">
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               :disabled="selectedJoints.length <= 0"
                               dark
                               v-on="on"
                               @click.stop="deleteSelected"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">delete</v-icon>
                        </v-btn>
                    </template>
                    <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               @click.stop="minimized = !minimized"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">{{ minimized ? 'maximize' : 'minimize' }}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ minimized ? 'Maximize' : 'Minimize' }}</span>
                </v-tooltip>

                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-btn icon
                               dark
                               v-on="on"
                               @click.stop="hide"
                               @dblclick.stop="">
                            <v-icon :size="iconSize">close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </v-app-bar>

            <v-card v-if="!minimized">
                <div class="pl-5 pr-5" >
                    <v-data-table
                            show-select
                            disable-sort
                            v-model="selectedJoints"
                            :headers="headers"
                            item_key="id"
                            :items="joints"
                            :options.sync="pagination"
                            :hide-default-footer="true"
                            class="elevation-1 fixed-column-table"
                    >
                        <template v-slot:body="{ items }">
                            <tr v-for="(item) in items" :key="item.id">
                                <td>
                                    <v-checkbox v-model="selectedJoints" :value="item" class="checkbox ma-0 pa-0"
                                                hide-details></v-checkbox>
                                </td>
                                <td class="text-left">
                                    <div class="helpIcon" style="width: auto; height: auto">
                                        <span>{{ item.volumes[0] }}</span>
                                        <span v-for="i in Math.min(item.volumes.length - 1, 2)" :key="i">
                                            <br>{{ item.volumes[i] }}
                                        </span>
                                        <span v-if="item.volumes.length > 3">...</span>
                                    </div>
                                    <span v-if="item.volumes.length > 3" class="helpText" style="left: 75%; top: auto;">
                                        <span v-for="volume in item.volumes" :key="volume">
                                            {{ volume }}<br>
                                        </span>
                                    </span>
                                </td>
                                <td class="text-left">{{ item.type }}</td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-btn
                            v-if="pagination.pageCount === 0 || pagination.page === pagination.pageCount"
                            class="add-button"
                            @click="addJoint">
                        +
                    </v-btn>
                    <v-card-actions class="justify-center" v-if="!isRegisteredUser()">
                        <h3 style="color: red">You are not logged in, changes done won't be saved.</h3>
                    </v-card-actions>
                    <v-pagination
                            v-model="pagination.page"
                            :length="pagination.pageCount"
                            :total-visible="5"
                    >
                    </v-pagination>
                </div>
            </v-card>
        </minimizable-modal>

        <joint-creator :bus="creatorBus" :chainID="chainID"></joint-creator>
    </div>
</template>

<script>
    import MinimizableModal from '../../../components/minimizable-modal'
    import JointCreator from './joint-creator';
    import controller from '../controller';
    import {mapState, mapActions} from 'vuex';
    import Vue from 'vue';

    export default {
        name: "JointList",

        components: {
            MinimizableModal,
            JointCreator
        },

        props: {
            bus: {
                required: true,
            },
            chainID: {
                required: true
            }
        },

        computed: {
            ...mapState('kinematics', {
                chains: 'chains'
            }),

            chain: {
                get() {
                    return this.chains.find(chain => chain.id === this.chainID);
                }
            },

            joints: {
                get() {
                    return this.chain.nodes.map(node => node.children[0]).filter(joint => !!joint);
                }
            }
        },

        watch: {
            joints: function () {
                this.pagination.totalItems = this.joints.length;
                this.pagination.pageCount = Math.ceil(this.joints.length / 5);
                this.pagination.page = this.pagination.pageCount;
            }
        },

        data() {
            return {
                name: "jointList",
                headers: [
                    {text: 'Volume', value: 'volumes', align: 'left', width: '75%', sortable: true},
                    {text: 'Type', value: 'type', align: 'left', width: '25%', sortable: true},
                ],
                pagination: {
                    descending: true,
                    page: 1,
                    itemsPerPage: 5,
                    totalItems: 0,
                    pageCount: 1
                },
                minimized: false,
                visible: false,
                modalShift: {
                    x: 0.0,
                    y: 0.5
                },
                iconSize: 25,
                selectedJoints: [],
                controller: controller,
                creatorBus: new Vue()
            }
        },

        created() {
            this.bus.$on('show', this.show);
            this.bus.$on("hideAll", this.hideAll);
            this.pagination.totalItems = this.joints.length;
            this.pagination.pageCount = Math.ceil(this.joints.length / this.pagination.itemsPerPage);
        },

        methods: {
            ...mapActions('kinematics', {
                deleteJoint: 'deleteJointFromChain',
                start: 'start',
                stop: 'stop'
            }),

            isRegisteredUser: isRegisteredUser,

            addJoint() {
                this.creatorBus.$emit("show");
            },

            startChain() {
                this.start(this.chainID);
            },

            deleteSelected() {
                for (let joint of this.selectedJoints) {
                    this.deleteJoint({
                        id: this.chainID,
                        joint: joint
                    });
                }

                this.selectedJoints.splice(0, this.selectedJoints.length);
            },

            show() {
                this.visible = true;
            },

            hide() {
                this.minimized = false;
                this.visible = false;
            },

            hideAll() {
                this.creatorBus.$emit("hideAll");
                this.hide();
            }
        }
    }
</script>

<style scoped>
    .v-text-field >>> input {
        margin: 0;
    }

    .add-button {
        width: 100%;
        border: 2px white dashed;
        background-color: transparent;
        font-size: 45px;
        padding: 20px 0 !important;
        margin: 10px 0;
    }
</style>
